__turbopack_context__.v({
  "button": "mBFmKG_button",
  "color--b": "mBFmKG_color--b",
  "color--c": "mBFmKG_color--c",
  "color--g": "mBFmKG_color--g",
  "color--r": "mBFmKG_color--r",
  "color--u": "mBFmKG_color--u",
  "color--w": "mBFmKG_color--w",
  "container": "mBFmKG_container",
  "icon": "mBFmKG_icon",
  "isColorlessDisabled": "mBFmKG_isColorlessDisabled",
  "isSelected": "mBFmKG_isSelected",
  "lock": "mBFmKG_lock",
  "variant--horizontal": "mBFmKG_variant--horizontal",
});
